import React from 'react';
import { Link } from 'react-router-dom';

const ServiceCard = ({ icon, title, description, link }) => {
  return (
    <div className="bg-white shadow-lg rounded-lg p-6 transition-all duration-500 ease-in-out transform hover:-translate-y-2 hover:shadow-2xl md:h-[450px] lg:h-[400px] xl:h-[350px] flex flex-col">
      <div className="mb-4 text-blue-600 transition-transform duration-500 ease-in-out group-hover:scale-110">
        {icon}
      </div>

      <h3 className="text-xl font-bold mb-3 text-gray-800 transition-colors duration-300">
        <Link to={link} className="hover:text-blue-600 transition-colors">
          {title}
        </Link>
      </h3>

      {/* Scrollable or clamped description */}
      <div className="text-gray-600 mb-4 overflow-hidden flex-1 transition-all duration-500 ease-in-out">
        <p className="line-clamp-8">{description}</p>
      </div>

      {/* Read More Button at Bottom */}
      <Link
        to={link}
        className="text-blue-600 font-medium inline-flex items-center hover:text-blue-800 transition-colors mt-auto"
      >
        Read More
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 ml-1 transition-transform duration-300 group-hover:translate-x-1"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </Link>
    </div>
  );
};

export default ServiceCard;
